import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row } from 'antd';
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { Links } from "../../helpers/Links";
import { TaiSan } from "../../models/taisan/TaiSan";
import LoadingDetailPage from "../../modules/loading/LoadingDetailPage";
import { layChiTietTaiSan } from "../../services/taisan";
import LuuTaiSanBox from "./LuuTaiSanBox";

const ChiTietTaiSan = () => {
    const navigate = useNavigate();
    const [taiSan, setTaiSan] = useState<TaiSan | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    // Lấy id từ query string
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');

    const isThemMoi = !id;

    const loadChiTiet = async () => {
        if (!id) return;
        
        try {
            setIsLoading(true);
            const result = await layChiTietTaiSan(parseInt(id));
            setTaiSan(result);
        } catch (error: any) {
            toast.error('Lỗi khi tải chi tiết tài sản: ' + error.message);
            navigate(Links.TaiSan.DanhSach);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmitSuccess = () => {
        navigate(Links.TaiSan.DanhSach);
    };

    useEffect(() => {
        if (id) {
            loadChiTiet();
        }
    }, [id]);

    if (isLoading && id) {
        return <LoadingDetailPage title={isThemMoi ? "Thêm mới tài sản" : "Chỉnh sửa tài sản"} />;
    }

    return (
        <section>
            <ContentHeader title={isThemMoi ? "Thêm mới tài sản" : "Chỉnh sửa tài sản"} />
            <Row>
                <Col span={24}>
                    <div className="card">
                        <div className="card-body">
                            <LuuTaiSanBox
                                modelProps={taiSan}
                                onSubmit={handleSubmitSuccess}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default ChiTietTaiSan;
